/**
 * Wrapper on top of HTMLElement for setting position and size of HTML elements.
 */
class HTMLBox {
  /**
   * Creates an instance of HTMLBox.
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.el = el;
  }

  /**
   * Converts numbers to pixels and lets strings be
   * @static
   * @param {Number|String} size
   */
  static toUnit(size) {
    return typeof size == 'number' ? size + 'px' : size;
  }

  /**
   * Returns boundingClientRect
   * @readonly
   */
  get box() {
    return this.el.getBoundingClientRect();
  }

  get width() {
    return this.box.width;
  }
  set width(width) {
    this.el.style.width = HTMLBox.toUnit(width);
  }

  get height() {
    return this.box.height;
  }
  set height(height) {
    this.el.style.height = HTMLBox.toUnit(height);
  }

  get top() {
    return this.box.y;
  }
  set top(top) {
    this.el.style.top = HTMLBox.toUnit(top);
  }

  get left() {
    return this.box.x;
  }
  set left(left) {
    this.el.style.left = HTMLBox.toUnit(left);
  }
}

export default HTMLBox;
